import { render, staticRenderFns } from "./Imagens.vue?vue&type=template&id=615a1329&scoped=true&"
import script from "./Imagens.vue?vue&type=script&lang=js&"
export * from "./Imagens.vue?vue&type=script&lang=js&"
import style0 from "./Imagens.vue?vue&type=style&index=0&id=615a1329&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a1329",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
